/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../../app/@shared/tracking/tracking.module';
import * as i2 from './tracking.component.ngfactory';
import * as i3 from '@angular/http';
import * as i4 from 'ngx-cookie/src/cookie-options-provider';
import * as i5 from '../../../../app/@shared/tracking/error-tracking.service';
import * as i6 from '../../../../app/@shared/auth/auth.service';
import * as i7 from '../../../../app/@shared/tracking/tracking.config';
import * as i8 from 'ngx-cookie/index';
import * as i9 from '../../../../app/@shared/auth/auth.module';
export const TrackingModuleNgFactory:i0.NgModuleFactory<i1.TrackingModule> = i0.ɵcmf(i1.TrackingModule,
    ([] as any[]),(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[i2.TrackingComponentNgFactory]],[3,i0.ComponentFactoryResolver],i0.NgModuleRef]),
          i0.ɵmpd(4608,i3.BrowserXhr,i3.BrowserXhr,([] as any[])),i0.ɵmpd(4608,i3.ResponseOptions,
              i3.BaseResponseOptions,([] as any[])),i0.ɵmpd(4608,i3.XSRFStrategy,i1.NoXSRFStrategy,
              ([] as any[])),i0.ɵmpd(4608,i3.XHRBackend,i3.XHRBackend,[i3.BrowserXhr,
              i3.ResponseOptions,i3.XSRFStrategy]),i0.ɵmpd(4608,i3.RequestOptions,
              i3.BaseRequestOptions,([] as any[])),i0.ɵmpd(5120,i3.Http,i3.ɵc,[i3.XHRBackend,
              i3.RequestOptions]),i0.ɵmpd(4608,i4.CookieOptionsProvider,i4.CookieOptionsProvider,
              [i4.COOKIE_OPTIONS,i0.Injector]),i0.ɵmpd(4608,i5.ErrorTracking,i5.ErrorTracking,
              [i6.Auth,i7.TRACKING_CONFIG]),i0.ɵmpd(512,i3.HttpModule,i3.HttpModule,
              ([] as any[])),i0.ɵmpd(512,i8.CookieModule,i8.CookieModule,([] as any[])),
          i0.ɵmpd(512,i9.AuthModule,i9.AuthModule,([] as any[])),i0.ɵmpd(512,i1.TrackingModule,
              i1.TrackingModule,([] as any[]))]);
    });
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvdHJhY2tpbmcubW9kdWxlLm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvdHJhY2tpbmcubW9kdWxlLnRzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build/webapp/src/$$_gendir/app/@shared/tracking/tracking.module.ngfactory.ts